import { i18n } from 'i18n';
import {
  BinderSupplierDto,
  BinderSupplierForm
} from './api';
import {
  makeCreateMutation,
  makeDeleteMutation,
  makeGetQuery,
  makeListQuery,
  makeUpdateMutation
} from './useApi';

const BINDER_SUPPLIERS_KEY = 'binder-suppliers';
const BINDER_SUPPLIER_KEY = 'binder-supplier';

export const useBinderSuppliersQuery = makeListQuery<string, BinderSupplierDto[]>(
  BINDER_SUPPLIERS_KEY,
  (api, projectId) => () => api.binderSuppliers.getByProject(projectId),
);

export const useBinderSupplierQuery = makeGetQuery<BinderSupplierDto, string>(
  BINDER_SUPPLIER_KEY,
  (api, entityId) => () => api.binderSuppliers.get(entityId),
);

export interface CreateBinderSupplierParams {
  binderSupplierForm: BinderSupplierForm;
  projectId: string;
}

export const useCreateBinderSupplierMutation = makeCreateMutation<string, CreateBinderSupplierParams>(
  BINDER_SUPPLIERS_KEY,
  (api) => (binderSupplierParams) => api.binderSuppliers.create(binderSupplierParams.projectId, binderSupplierParams.binderSupplierForm),
  () => i18n._('A new binder supplier was successfully created'),
);

export const useUpdateBinderSupplierMutation = makeUpdateMutation<void, BinderSupplierForm>(
  BINDER_SUPPLIER_KEY,
  BINDER_SUPPLIERS_KEY,
  (api, entityId) => (form) => api.binderSuppliers.update(entityId, form),
  () => i18n._('Successfully updated the Binder Supplier'),
);

export const useDeleteBinderSupplierMutation = makeDeleteMutation<void, BinderSupplierDto>(
  BINDER_SUPPLIER_KEY,
  BINDER_SUPPLIERS_KEY,
  (api) => (binderSupplier) => api.binderSuppliers.delete(binderSupplier.entityId),
  () => i18n._('Successfully deleted the Binder Supplier'),
  (binderSupplier) => binderSupplier.entityId,
);
